var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-tag-view-item-model",class:{active:_vm.isActiveUrl},attrs:{"id":_vm.id},on:{"click":function($event){$event.stopPropagation();return _vm.onToPath($event,_vm.item)}}},[_c('span',{attrs:{"data-path":_vm.item.path}},[_vm._v(_vm._s(_vm.title)+" "),(_vm.num > 0)?_c('span',[_vm._v("("+_vm._s(_vm.num)+")")]):_vm._e()]),_vm._v(" "),_c('b',{on:{"click":function($event){$event.stopPropagation();return _vm.onClose.apply(null, arguments)}}},[_c('i',{staticClass:"el-icon-circle-close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/tagViewItem.vue